module.exports = __webpack_public_path__ + "static/media/icon-ReturningPlayer.ff7121f6.svg";